import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useFormState } from 'react-use-form-state'
import { useContext } from '@/store'
import getLocalizedContent from '@/utils/getLocalizedContent'
import * as UI from '@/components/UI'
import {
  Section,
  Form,
  Lines,
  Line,
  Message,
  MessageLabel,
  SuccessWrapper,
  WrapperPhone,
  WrapperInterest,
  WrapperEmail,
  WrapperName,
} from './Contact.css'

const contactQuery = graphql`
  query ContactQuery {
    content: allPrismicContactPage {
      edges {
        node {
          lang
          data {
            contact_title
            contact_1
            contact_1_placeholder
            email
            email_placeholder
            phone
            phone_placeholder
            contact_2
            contact_2_options {
              option
            }
            contact_3
            contact_3_placeholder
            contact_4
            contact_4_options {
              option
            }
            contact_5
            contact_5_options {
              option
            }
            contact_5_1
            contact_button
            contact_message
            contact_message_placeholder
            success_title
          }
        }
      }
    }
  }
`

const encode = data => {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&')
}

const Contact = ({ ...props }) => {
  const { locale } = useContext()
  const data = useStaticQuery(contactQuery)
  const content = getLocalizedContent(data, locale)

  const [step, setStep] = useState('initial')
  const [state, { text, select, textarea }] = useFormState()

  const isValid =
    Object.keys(state.validity).length === Object.keys(state.values).length &&
    Object.values(state.validity).every(x => x)

  const disabled = !(isValid || step === 'initial')

  const handleSubmit = e => {
    e.preventDefault()
    setStep('loading')
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...state.values }),
    })
      .then(() => setStep('submitted'))
      .catch(error => console.error(error))
  }

  return (
    <Section {...props}>
      <UI.Container>
        <UI.Grid>
          {(step === 'initial' || step === 'loading') && (
            <Form name='contact' data-netlify='true' onSubmit={handleSubmit}>
              <UI.SectionTitle>{content.contact_title}</UI.SectionTitle>
              <Lines>
                <Line>
                  <label htmlFor='fullName'>{content.contact_1}</label>
                  <WrapperName>
                    <UI.Input
                      {...text('fullName')}
                      isForm
                      maxWidthMobile='110px'
                      required
                      default
                      placeholder={content.contact_1_placeholder}
                    />
                  </WrapperName>
                  ,
                </Line>
                <Line>
                  <label htmlFor='fullName'>{content.email}</label>
                  <WrapperEmail>
                    <UI.Input
                      {...text('email')}
                      isForm
                      required
                      maxWidthMobile='110px'
                      default
                      placeholder={content.email_placeholder}
                    />
                  </WrapperEmail>
                  .
                </Line>
                <Line>
                  <label htmlFor='phone'>{content.phone}</label>
                  <WrapperPhone>
                    <UI.Input
                      isForm
                      {...text('phone')}
                      default
                      placeholder={content.phone_placeholder}
                    />
                  </WrapperPhone>
                  .
                </Line>
                <Line>
                  <label htmlFor='interest'>{content.contact_4}</label>
                  <WrapperInterest>
                    <UI.Select
                      isForm
                      {...select('interest')}
                      maxWidthMobile='110px'
                    >
                      <option value='' />
                      {content.contact_4_options?.map(({ option }) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </UI.Select>
                  </WrapperInterest>
                  .
                </Line>
                <Line>
                  <label htmlFor='ammount'>{content.contact_5}</label>
                  <div>
                    <UI.Select {...select('ammount')} isForm>
                      <option value='' />
                      {content.contact_5_options?.map(({ option }) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </UI.Select>
                  </div>
                  <div>{content.contact_5_1}.</div>
                </Line>
              </Lines>
              <Message>
                <MessageLabel>{content.contact_message}</MessageLabel>
                <UI.TextArea
                  {...textarea('message')}
                  rows={1}
                  placeholder={content.contact_message_placeholder}
                />
              </Message>
              <UI.Button
                type='submit'
                appearance={!disabled ? 'blue' : 'ghost'}
                disabled={disabled}
              >
                {content.contact_button}
              </UI.Button>
            </Form>
          )}
          {step === 'submitted' && (
            <SuccessWrapper>
              <UI.SectionTitle>{content.success_title}</UI.SectionTitle>
            </SuccessWrapper>
          )}
        </UI.Grid>
      </UI.Container>
    </Section>
  )
}

export default Contact
